/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from 'react';
import LabeledInputWithBlur from '../../../../sharedmodules/components/form-fields/labeled-input-with-blur';
import MultipleUsersDealers from './multiple-users-dealers';
import PropTypes from 'prop-types';
import { validateDealerDetails } from '../../services/users-settings-helper';

const UserDealerInputField = ({ handleExecute, handleReset }) => {

    const [userDetails, setUserDetails] = useState({ userId: '', dealerAccount: '' });
    const [isMultipleVisible, setIsMultipleVisible] = useState(false);
    let isVsrError = '';

    const [fieldTouch, setFieldTouched] = useState({
        userId: false, dealerAccount: false,
    });
    const [label, setLabel] = useState('');

    const handleInputChange = (e) => {

        e.preventDefault();
        setUserDetails({
            ...userDetails,
            [e.target.name]: e.target.value,
        });
        setFieldTouched({
            ...fieldTouch,
            [e.target.name]: true,
        });

    };

    const isValidDetails = (fieldTouchValue, userDetailsValue, alternateData) => {

        isVsrError = validateDealerDetails(fieldTouchValue, userDetailsValue);
        return (fieldTouchValue && userDetailsValue !== '' && isVsrError === '') || (alternateData !== '' && isVsrError === '') || !fieldTouchValue;

    };

    const validateExecuteButton = () => !isValidDetails(true,
        userDetails.dealerAccount,
        userDetails.userId) ||
    !isValidDetails(true,
        userDetails.userId,
        userDetails.dealerAccount);

    const addMultipleData = (labelValue) => {

        setIsMultipleVisible(true);
        setLabel(labelValue);

    };

    const handleSubmit = (labelData, data) => {

        if (labelData === 'DEALER_ACCOUNT') {

            setUserDetails({
                ...userDetails,
                dealerAccount: data,
            });

        } else {

            setUserDetails({
                ...userDetails,
                userId: data,
            });

        }
        if (data !== '') {

            setIsMultipleVisible(false);

        }

    };

    return (
        <div className="dealer-settings-body">
            <div className="input-details">
                <div className="input-fields">
                    <LabeledInputWithBlur
                        className="user-id"
                        name="userId"
                        errorMessage="USERID_IS_REQUIRED"
                        highlightClass={isValidDetails(fieldTouch.userId, userDetails.userId, userDetails.dealerAccount) ? '' : 'highlight-error'}
                        isEditable
                        isValid={isValidDetails(fieldTouch.userId, userDetails.userId, userDetails.dealerAccount) || isVsrError !== ''}
                        label="USER_ID"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={userDetails.userId}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                    <LabeledInputWithBlur
                        className="dealer-account"
                        name="dealerAccount"
                        errorMessage="DEALER_ACCOUNT_IS_REQUIRED"
                        highlightClass={isValidDetails(fieldTouch.dealerAccount, userDetails.dealerAccount, userDetails.userId) ? '' : 'highlight-error'}
                        isEditable
                        isValid={isValidDetails(fieldTouch.dealerAccount, userDetails.dealerAccount, userDetails.userId) || isVsrError !== ''}
                        label="DEALER_ACCOUNT"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={userDetails.dealerAccount}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                </div>
                {isMultipleVisible && (
                    <MultipleUsersDealers
                        handleSubmit={handleSubmit}
                        label={label}
                        onClose={() => setIsMultipleVisible(false)}
                        userDetails={userDetails}
                    />
                )}
            </div>
            <div className="button-layout">
                <button
                    type="button"
                    onClick={() => {

                        setUserDetails({ userId: '', dealerAccount: '' }); handleReset();

                    }}
                >

Reset
                </button>
                <button type="button" id="execute" onClick={() => handleExecute(userDetails)} disabled={validateExecuteButton()}>

Execute
                </button>
            </div>
        </div>

    );

};

UserDealerInputField.propTypes = {
    handleExecute: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
};

export default UserDealerInputField;
